import { connect } from 'react-redux';
import backToSignIn from './ResetPasswordActions';
import CheckYourInBox from './CheckYourInBox';

const mapDispatchToProps = dispatch => ({
  onBackToSignIn: () => dispatch(backToSignIn()),
});

const CheckYourInBoxContainer = connect(null, mapDispatchToProps)(CheckYourInBox);
export default CheckYourInBoxContainer;
